<!-- eslint-disable -->
<template lang="pug">
    .max-login-widget
        cs-button(
            v-if="!isLoading && !isVerified"
            @click="onMaxAuthRequest"
            size="small"
            color="blue"
        ) {{ $i18n.t('max.verify_with_max') }}
        cs-loader(v-if="isLoading" size="base")
        .max-login-widget__verified(v-if="isVerified")
            svg-icon.max-login-widget__icon(name="check" size="small")
            span {{ $i18n.t('max.max_verified') }}
</template>

<script>
    /*eslint-disable*/
    import UserApi from '../api/user/user';

    const POLL_INTERVAL_MS = 2000;
    const POLL_TIMEOUT_MS = 60000;

    export default {
        name: 'MaxLoginWidget',
        props: {
            /**
             * Initial verified state
             */
            verified: {
                type: [Boolean, Number],
                default: false,
            },
            adminId: {
                type: Number,
                required: true,
            },
            pollWithAdminInfo: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isLoading: false,
                isVerified: this.verified,
                pollTimer: null,
            };
        },
        watch: {
            verified(newVal) {
                this.isVerified = newVal;
            },
        },
        beforeDestroy() {
            this.stopPolling();
        },
        methods: {
            async onMaxAuthRequest() {
                this.isLoading = true;
                try {
                    const botName = 'id5032278135_1_bot';
                    window.open(`https://max.ru/${botName}?start=${this.adminId}`, '_blank');
                    this.$toasted.info(this.$i18n.t('max.follow_bot_instructions'));
                    const user = await this.waitForVerification();
                    if (user) {
                        this.isVerified = true;
                        this.$emit('verified', { user });
                        this.$toasted.success(this.$i18n.t('max.max_linked_success'));
                    } else {
                        this.$toasted.error(this.$i18n.t('max.verification_failed'));
                    }
                } catch (error) {
                    console.error('Failed to initiate MAX verification', error);
                    this.$toasted.error(this.$i18n.t('max.verification_failed'));
                } finally {
                    this.isLoading = false;
                }
            },
            waitForVerification() {
                const deadline = Date.now() + POLL_TIMEOUT_MS;

                return new Promise((resolve) => {
                    const tick = async () => {
                        if (Date.now() > deadline) {
                            this.stopPolling();
                            resolve(null);
                            return;
                        }

                        try {
                            const user = await this.fetchPolledUser();
                            if (user && user.maxVerified) {
                                this.stopPolling();
                                resolve(user);
                                return;
                            }
                        } catch (error) {
                            console.error('Failed to poll MAX verification', error);
                        }

                        this.pollTimer = setTimeout(tick, POLL_INTERVAL_MS);
                    };

                    this.pollTimer = setTimeout(tick, POLL_INTERVAL_MS);
                });
            },
            async fetchPolledUser() {
                if (this.pollWithAdminInfo) {
                    const adminInfo = await UserApi.getAdminInfo();
                    return adminInfo && adminInfo.user;
                }

                return UserApi.show(this.adminId);
            },
            stopPolling() {
                if (this.pollTimer) {
                    clearTimeout(this.pollTimer);
                    this.pollTimer = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .max-login-widget {
        display: flex;
        align-items: center;
    }

    .max-login-widget__verified {
        display: flex;
        align-items: center;
        color: $hsl-color-green-58;
        font-size: 16px;
        line-height: 19px;
        justify-content: center;
    }

    .max-login-widget__icon {
        margin-right: 8px;
    }
</style>
